<template>
  <div>
    <Header />
      <FlashMessage ref="flashMessage" />
    <div class="orders-page">
      <h1>My Orders</h1>

      <!-- Order List -->
      <div class="order-list">
        <LoadingIndicator v-if="loading" message="Loading..." />

        <div class="order-card" v-for="order in orders" :key="order.id">
          <div class="order-header">
            <h3>Order #{{ order.order_number }}</h3>
            <p class="order-date">{{ formatDate(order.created_at) }}</p>
          </div>
          <div class="order-details">
            <p><strong>Payment:</strong> {{ order.payment_status.name }}</p>
            <p><strong>Total:</strong> Tsh:{{ order.total_amount }}</p>
            <p><strong>Status:</strong> {{ order.order_status.name }}</p>
          </div>
          <div class="order-actions">
          <button class="view-details-btn" title="View Details" @click="viewOrderDetails(order.id)">
            <i class="fas fa-info-circle"></i>
          </button>
            <button
              title="Verify Payment"
              class="view-details-btn"
              v-if="order.payment_status?.name !== 'Paid'"
              @click="VerifyPayment(order.latest_transaction.id)"
            >
            <i class="fas fa-check-circle"></i>
            </button>
            <button
              title="Retry Payment"
              class="view-details-btn"
              v-if="order.payment_status.name != 'Paid'"
              @click="RetryPayment(order.id)"
            >
            <i class="fas fa-redo"></i>
            </button>
            <!-- <button
              class="cancel-btn"
              v-if="order.payment_status.name === 'Pending'"
              @click="cancelOrder(order.id)"
            >
              Cancel Order
            </button> -->
          </div>
        </div>
      </div>

      <!-- Order Details Modal -->
      <div class="order-details-modal" v-if="selectedOrder">
        <div class="modal-content">
          <span class="close-btn" @click="selectedOrder = null">&times;</span>
          <h2>Order #{{ selectedOrder.order_number }}</h2>
          <p><strong>Date:</strong> {{ formatDate(selectedOrder.created_at) }}</p>
          <p><strong>Status:</strong> {{ selectedOrder.order_status.name }}</p>
          <p><strong>Total:</strong> Tsh:{{ selectedOrder.total_amount }}</p>

          <!-- Products in Order -->
          <div class="products-list">
            <h3>Products</h3>
            <div
              class="product-item"
              v-for="product in selectedOrder.items"
              :key="product.id"
            >
              <img 
                :src="getFullImageUrl(product.product.thumbnail)"
               :alt="product.name" />
              <div class="product-info">
                <h4>{{ product.product.name }}</h4>
                <p>Quantity: {{ product.quantity }}</p>
                <p>Price: Tsh:{{ product.product.price }}</p>
              </div>
            </div>
          </div>

          <!-- Shipping Address -->
          <div class="shipping-address">
            <h3>Shipping Address</h3>
            <p>{{ selectedOrder.shipping_address }}</p>
          </div>

          <!-- Payment Method -->
          <div class="payment-method">
            <h3>Payment Method</h3>
            <p>{{ selectedOrder.payment_method.name }}</p>
          </div>

          <!-- Tracking Information -->
          <div class="tracking-info">
            <h3>Tracking Information</h3>
            <p>
              Tracking Number:
              <a :href="selectedOrder.trackingLink" target="_blank">
                {{ selectedOrder.order_number }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Header from "../components/Header.vue";
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import FlashMessage from "@/components/FlashMessage.vue";
import LoadingIndicator from "@/components/Loading_indicator.vue";
import {
  API_BASE_URL,
  RemoveProductFromCart,
  ReduceAddCartItemsNumber,
  getMyOrders,
  PaymentRefresh,
  PaymentRetry,
} from "../API-requests/Requests";


const router = useRouter();

const orders = ref([]);
const loading = ref(true);
// Selected Order for Details Modal
const selectedOrder = ref(null);
const flashMessage = ref(null);
const error = ref(null);


//we need to customize dates data
function formatDate(dateString) {
const date = new Date(dateString);

  const options = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  return date.toLocaleString('en-US', options);
}

// View Order Details
const viewOrderDetails = (orderId) => {
  selectedOrder.value = orders.value.find((order) => order.id === orderId);
};

// Cancel Order
const cancelOrder = (orderId) => {
  const order = orders.value.find((order) => order.id === orderId);
  if (order && order.status === "Processing") {
    order.status = "Cancelled";
    alert(`Order #${orderId} has been cancelled.`);
  }
};

//verify payment
const VerifyPayment = async (transaction_id) => {
  try {
    loading.value =true;
    const response = await PaymentRefresh(transaction_id);
    flashMessage.value.showFlashMessage(
      "success",
      "Payment Verified Succesfully!"
    );

    location.reload();

  } catch (err) {
    console.error("Error verifying payment!:", err);
    error.value = "Error verifying payment.";
    flashMessage.value.showFlashMessage("failure", error.value);
  }
  finally {
    loading.value = false;
  }
};


const RetryPayment = async (order_id) => {
  try {
    loading.value =true;
    const response = await PaymentRetry(order_id);


    flashMessage.value.showFlashMessage(
      "success",
      "Payment Payment retry has been set Succesfully!"
    );

    // applied payment method
    const appliedMethod = response.applied_p_method;

  // if was card payment
    if (
      appliedMethod === "Card" &&
      response.payment?.checkout_url
    ) {

      setTimeout(() => {

        // redirect to payment page
        window.location.href =
          response.payment.checkout_url;

      }, 1500);

      return;
    }

    //other normal payment methods
    setTimeout(() => {
      router.push("/order");
      // location.reload();
    }, 2000);

  } catch (err) {
    console.error("Error retrying payment!:", err);
    error.value = "Error retrying payment.";
    flashMessage.value.showFlashMessage("failure", error.value);
  }
  finally {
    loading.value = false;
  }
};


onMounted(async () => {
  try {
    const response = await getMyOrders();
    orders.value = response.data;
    console.log(orders);
  } catch (err) {
    console.error("Error fetching order data:", err);
    alert("Failed to load order data. Please try again later.");
  } finally {
    loading.value = false;
  }
});


const getFullImageUrl = (imagePath) => {
  return `${API_BASE_URL}${imagePath}`;
};

</script>

<style scoped>
/* General Styles */
.orders-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.orders-page h1 {
  font-size: 2rem;
  margin-bottom: 20px;
}

/* Order List */
.order-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.order-card {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.order-header h3 {
  font-size: 1.5rem;
  margin: 0;
}

.order-date {
  font-size: 0.9rem;
  color: #666;
}

.order-details {
  margin-bottom: 10px;
}

.order-details p {
  font-size: 1rem;
  margin: 5px 0;
}

.order-actions {
  display: flex;
  gap: 10px;
}

.view-details-btn,
.cancel-btn {
  padding: 10px 20px;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-details-btn {
  background-color: #42b983;
  color: #fff;
}

.view-details-btn:hover {
  background-color: #369f6e;
}

.cancel-btn {
  background-color: #ff4d4d;
  color: #fff;
}

.cancel-btn:hover {
  background-color: #cc0000;
}

/* Order Details Modal */
.order-details-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-content h2 {
  font-size: 1.8rem;
  margin-bottom: 10px;
}

.modal-content p {
  font-size: 1rem;
  margin: 5px 0;
}

.products-list {
  margin-top: 20px;
}

.products-list h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.product-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.product-item img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 8px;
}

.product-info h4 {
  font-size: 1.2rem;
  margin: 0;
}

.shipping-address,
.payment-method,
.tracking-info {
  margin-top: 20px;
}

.shipping-address h3,
.payment-method h3,
.tracking-info h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.tracking-info a {
  color: #007bff;
  text-decoration: none;
}

.tracking-info a:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .order-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .order-actions {
    flex-direction: column;
  }

  .view-details-btn,
  .cancel-btn {
    width: 100%;
  }
}
</style>